import { render, staticRenderFns } from "./SetupPureGeneric.vue?vue&type=template&id=b214e578"
import script from "./SetupPureGeneric.vue?vue&type=script&lang=js"
export * from "./SetupPureGeneric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports